<template>
    <div class="insight-card u-reset" ref="card">
        <div class="insight-card--content">
            <a :href="link" class="insight-card--link u-reset">
                <figure class="insight-card--figure" v-if="image">
                    <img class="insight-card--image" :src="image">
                </figure>
                <h3 class="insight-card--title u-reset" ref="title">{{ title }}</h3>
                <p class="insight-card--description" v-snip="{ lines: maxDescriptionLines }">{{ description }}</p>
            </a>
        </div>
        <div class="insight-card--footer">
            <dyn-insight-tags :tags="tags" class="insight-card--tag-list"/>
            <div class="insight-card--meta">
                <dyn-insight-authors :authors="authors" :and-separator="andSeparator" class="insight-card--authors"/>
                <div class="insight-card--info">
                    <div class="insight-card--date">
                        <dyn-insight-date :date="postDate" :language="language"/>
                    </div>
                    <div class="insight-card--readingtime" v-if="readingTime">
                        <dyn-insight-readingtime :value="readingTime" :language="language"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';

    export default {
        mixins: [bemMixin('insight-card')],
        props: {
            title: {
                type: String,
                required: true,
            },
            tags: {
                type: Array,
                default: () => [],
            },
            link: {
                type: String,
                required: true,
            },
            description: {
                type: String,
                default: null,
            },
            id: {
                type: Number,
                required: true,
            },
            image: {
                type: String,
                default: null,
            },
            postDate: {
                type: Number,
                default: null,
            },
            readingTime: {
                type: Number,
                default: null,
            },
            language: {
                type: String,
                default: 'de',
            },
            authors: {
                type: Array,
                default: () => [],
            },
            andSeparator: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                lines: 0,
                ro: null,
            };
        },
        computed: {
            maxDescriptionLines() {
                return 6 - this.lines;
            },
        },
        methods: {
            generateTagLink(tag) {
                return `${ window.location.pathname }?query=${ encodeURIComponent(tag.title) }`;
            },
            countTitleLines() {
                const divHeight = this.$refs.title.offsetHeight;
                const lineHeight = parseInt(window.getComputedStyle(this.$refs.title).lineHeight);
                this.lines = Math.round(divHeight / lineHeight);
            },
        },
        beforeDestroy() {
            this.ro.unobserve(this.$refs.card);
        },
        mounted() {
            this.ro = new ResizeObserver(this.countTitleLines);
            this.ro.observe(this.$refs.card);
        },
    };
</script>
